(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gamdru-collection-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function readCount() {
      // Horizon renderiza el nº de resultados (ya filtrado) dentro de la
      // sección de la colección; lo tomamos de ahí y lo copiamos a la cabecera.
      var src =
        document.querySelector('[data-results-count]') ||
        document.querySelector('[data-testid="products-count"]') ||
        document.querySelector('.products-count-wrapper');
      if (!src) return null;
      var raw = src.getAttribute('data-results-count');
      if (raw == null) raw = src.textContent || '';
      var m = String(raw).replace(/[.,](?=\d{3}\b)/g, '').match(/\d+/);
      return m ? parseInt(m[0], 10) : null;
    }

    function sync() {
      var target = document.querySelector('[data-gch-count]');
      if (!target) return;
      var n = readCount();
      if (n == null || isNaN(n)) return;
      target.textContent = n + ' ' + (n === 1 ? 'artículo' : 'artículos');
      target.hidden = n === 0;
    }

    function bump() {
      sync();
      requestAnimationFrame(sync);
      [80, 250, 600, 1200].forEach(function (t) { setTimeout(sync, t); });
    }

    function start() {
      bump();

      // Horizon emite estos eventos al re-renderizar la colección tras filtrar
      document.addEventListener('collection:update', bump);
      document.addEventListener('search:update', bump);
      document.addEventListener('shopify:section:load', bump);

      var scope =
        document.querySelector('results-list') ||
        document.querySelector('#ResultsList') ||
        document.querySelector('.collection-wrapper') ||
        document.body;
      if (!scope || !window.MutationObserver) return;
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          sync();
        });
      }).observe(scope, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-results-count'],
        characterData: true,
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gamdru-email-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-epop]');
    if (!root) return;

    var STORAGE_KEY = 'gamdru_epop_state';
    var SCROLL_KEY = 'gamdru_epop_scroll';
    var hasSuccess = /[?&]epop_ok=1(&|$)/.test(window.location.search);

    if (hasSuccess) {
      var okBlock = root.querySelector('[data-epop-ok]');
      var fieldsBlock = root.querySelector('[data-epop-fields]');
      if (okBlock) okBlock.hidden = false;
      if (fieldsBlock) fieldsBlock.hidden = true;

      // Quita el "?epop_ok=1" de la barra de direcciones sin recargar.
      var cleanUrl = window.location.pathname + window.location.hash;
      window.history.replaceState(null, '', cleanUrl);

      // El envío recarga la página entera (vuelve al scroll 0): restauramos
      // dónde estaba la persona justo antes de enviar el formulario.
      try {
        var savedScroll = parseInt(sessionStorage.getItem(SCROLL_KEY), 10) || 0;
        window.scrollTo(0, savedScroll);
        // Reafirma tras el load, por si las imágenes desplazan el layout.
        window.addEventListener('load', function () { window.scrollTo(0, savedScroll); });
        sessionStorage.removeItem(SCROLL_KEY);
      } catch (e) { /* sessionStorage no disponible: se queda arriba, no pasa nada */ }
    }

    root.querySelectorAll('form').forEach(function (form) {
      form.addEventListener('submit', function () {
        try { sessionStorage.setItem(SCROLL_KEY, String(window.scrollY)); }
        catch (e) { /* no pasa nada si no se puede guardar */ }
      });
    });

    function readState() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'); }
      catch (e) { return {}; }
    }
    function writeState(state) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); }
      catch (e) { /* localStorage no disponible: no persistimos, no pasa nada */ }
    }

    var state = readState();

    // Ya se suscribió alguna vez: no volver a mostrar nunca.
    if (state.subscribed) return;

    function show() {
      root.hidden = false;
      requestAnimationFrame(function () { root.classList.add('is-visible'); });
    }
    function hide() {
      root.classList.remove('is-visible');
      setTimeout(function () { root.hidden = true; }, 250);
    }

    if (hasSuccess) {
      // Venimos de un envío correcto (recarga tras el submit del form nativo).
      writeState({ subscribed: true });
      show();
    } else {
      var reshowDays = parseFloat(root.getAttribute('data-reshow-days')) || 14;
      var dismissedAt = state.dismissedAt || 0;
      var daysSince = (Date.now() - dismissedAt) / (1000 * 60 * 60 * 24);
      if (dismissedAt && daysSince < reshowDays) return;

      var delay = parseInt(root.getAttribute('data-delay'), 10) || 6000;
      setTimeout(show, delay);
    }

    root.querySelectorAll('[data-epop-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        writeState({ dismissedAt: Date.now() });
        hide();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) {
        writeState({ dismissedAt: Date.now() });
        hide();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gamdru-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // El enlace "Preferencias de cookies" lo inyecta el propio script de
    // privacidad de Shopify después de cargar la página (no está en
    // nuestro Liquid), así que esperamos a que aparezca para meter
    // "Contacto" justo detrás, en vez de fijar una posición a ciegas.
    function addContactLink(list, cookieLink) {
      if (list.querySelector('[data-gf-contact-link]')) return;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '/pages/contact';
      a.textContent = 'Contacto';
      a.setAttribute('data-gf-contact-link', '');
      li.appendChild(a);
      cookieLink.closest('li').after(li);
    }

    function findCookieLink(list) {
      return Array.prototype.find.call(list.querySelectorAll('a'), function (a) {
        return /preferencias de cookies/i.test(a.textContent);
      });
    }

    document.querySelectorAll('.gf__legal').forEach(function (list) {
      var existing = findCookieLink(list);
      if (existing) { addContactLink(list, existing); return; }

      var observer = new MutationObserver(function () {
        var link = findCookieLink(list);
        if (link) { addContactLink(list, link); observer.disconnect(); }
      });
      observer.observe(list, { childList: true, subtree: true });

      // Si Shopify nunca inyecta el enlace (privacidad desactivada, etc.),
      // no dejamos "Contacto" fuera: lo añadimos igual al final tras esperar.
      setTimeout(function () {
        if (!list.querySelector('[data-gf-contact-link]')) {
          observer.disconnect();
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '/pages/contact';
          a.textContent = 'Contacto';
          a.setAttribute('data-gf-contact-link', '');
          li.appendChild(a);
          list.appendChild(li);
        }
      }, 4000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gamdru-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-gh-video]').forEach(function (media) {
      var video = media.querySelector('.gh-sc__video');
      if (!video) return;
      var loaded = false;

      function play() {
        if (!loaded) { video.load(); loaded = true; }
        media.classList.add('is-playing');
        var pr = video.play();
        if (pr && pr.catch) pr.catch(function () {});
      }
      function stop() {
        media.classList.remove('is-playing');
        video.pause();
        try { video.currentTime = 0; } catch (e) {}
      }

      media.addEventListener('mouseenter', play);
      media.addEventListener('mouseleave', stop);
      media.addEventListener('focusin', play);
      media.addEventListener('focusout', stop);
    });
  })();

  (function () {
    document.querySelectorAll('.gh-slide--showcase').forEach(function (slide) {
      var bigImg = slide.querySelector('.gh-sc__img');
      var thumbs = slide.querySelectorAll('[data-gh-thumb]');
      if (!bigImg || !thumbs.length) return;
      var original = bigImg.getAttribute('src');
      var wrap = slide.querySelector('.gh-sc__thumbs');

      thumbs.forEach(function (t) {
        var full = t.getAttribute('data-full');
        if (full) {
          var pre = new Image();
          pre.src = full;
        }
        t.addEventListener('mouseenter', function () {
          if (full) bigImg.setAttribute('src', full);
        });
      });

      if (wrap) {
        wrap.addEventListener('mouseleave', function () {
          bigImg.setAttribute('src', original);
        });
      }
    });
  })();

  (function () {
    document.querySelectorAll('[data-gh-carousel].gh-carousel--multi').forEach(function (root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gh-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-gh-dot]'));
      if (slides.length < 2) return;

      var idx = 0;
      slides.forEach(function (s, i) { if (s.hasAttribute('data-active')) idx = i; });
      var timer = null;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function render() {
        slides.forEach(function (s, i) {
          if (i === idx) s.setAttribute('data-active', '');
          else s.removeAttribute('data-active');
        });
        dots.forEach(function (d, i) {
          if (i === idx) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      }

      function schedule() {
        clearTimeout(timer);
        if (reduce) return;
        var d = parseInt(slides[idx].getAttribute('data-duration'), 10);
        if (!d || d < 3000) d = 15000;
        timer = setTimeout(function () { go(idx + 1); }, d);
      }

      function go(n) {
        idx = (n % slides.length + slides.length) % slides.length;
        render();
        schedule();
      }

      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          go(parseInt(d.getAttribute('data-index'), 10));
        });
      });

      root.addEventListener('mouseenter', function () { clearTimeout(timer); });
      root.addEventListener('mouseleave', schedule);
      root.addEventListener('focusin', function () { clearTimeout(timer); });
      root.addEventListener('focusout', schedule);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) clearTimeout(timer);
        else schedule();
      });

      render();
      schedule();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* Gamdru: botón "Limpiar filtros" + filtros siempre desplegados (sin colapsar) */
  (function () {
    function relocate() {
      var form = document.querySelector('.facets-block-wrapper--vertical .facets__form');
      if (form && !form.querySelector('.gcol-clear-btn')) {
        var btn = document.createElement('a');
        btn.className = 'gcol-clear-btn';
        btn.href = form.getAttribute('action') || form.action || '?';
        btn.textContent = 'Limpiar filtros';
        form.appendChild(btn);
      }

      document
        .querySelectorAll('.facets-block-wrapper--vertical details.facets__panel')
        .forEach(function (d) {
          d.open = true;
          var s = d.querySelector('summary');
          if (s && !s.__gcolNoToggle) {
            s.__gcolNoToggle = true;
            s.addEventListener('click', function (e) { e.preventDefault(); });
          }
        });
    }
    function init() {
      relocate();
      var rl = document.querySelector('results-list');
      if (rl && window.MutationObserver) {
        new MutationObserver(function () { relocate(); }).observe(rl, { childList: true, subtree: true });
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  /* Gamdru: slider de precio de doble mango sobre los inputs de Horizon */
  (function () {
    var THUMB = 20; // px, igual que el CSS del thumb

    function num(v, fallback) {
      var n = parseFloat(v);
      return isNaN(n) ? fallback : n;
    }

    function readMax(range, maxR) {
      return (
        num(maxR && maxR.getAttribute('max'), 0) ||
        num(range.getAttribute('data-max'), 0) ||
        100
      );
    }

    /* Repinta SIEMPRE (aunque Horizon haya cambiado value/max en el sitio,
       sin reemplazar el elemento). Independiente de los listeners. */
    function repaint(range) {
      var minR = range.querySelector('.gcol-range__input--min');
      var maxR = range.querySelector('.gcol-range__input--max');
      if (!minR || !maxR) return;

      var fill = range.querySelector('.gcol-range__fill');
      var lblMin = range.querySelector('.gcol-range__lbl--min');
      var lblMax = range.querySelector('.gcol-range__lbl--max');
      var max = readMax(range, maxR);
      var sym = (lblMin && lblMin.textContent.replace(/[\d.,\s]/g, '')) || '€';

      var lo = Math.min(Math.max(num(minR.value, 0), 0), max);
      var hi = Math.min(Math.max(num(maxR.value, max), 0), max);
      if (lo > hi) lo = 0;

      if (String(lo) !== minR.value) minR.value = lo;
      if (String(hi) !== maxR.value) maxR.value = hi;

      var a = max ? lo / max : 0; // 0..1
      var b = max ? hi / max : 1; // 0..1

      if (fill) {
        // alinear los bordes del relleno con el CENTRO de cada bola,
        // teniendo en cuenta que el thumb no llega a los extremos del carril
        fill.style.left = 'calc(' + a * 100 + '% + ' + (0.5 - a) * THUMB + 'px)';
        fill.style.right = 'calc(' + (1 - b) * 100 + '% + ' + (b - 0.5) * THUMB + 'px)';
      }
      if (lblMin) lblMin.textContent = sym + lo;
      if (lblMax) lblMax.textContent = sym + hi;
    }

    /* Engancha los listeners una sola vez por elemento. */
    function attach(range) {
      var minR = range.querySelector('.gcol-range__input--min');
      var maxR = range.querySelector('.gcol-range__input--max');
      var comp = range.closest('price-facet-component');
      if (!minR || !maxR || !comp) return;
      if (range.__gcolBound) return;
      range.__gcolBound = true;

      var txtMin = comp.querySelector('[ref="minInput"]');
      var txtMax = comp.querySelector('[ref="maxInput"]');

      function gap() {
        return Math.max(1, Math.round(readMax(range, maxR) * 0.02));
      }

      function onInput(e) {
        var max = readMax(range, maxR);
        var lo = num(minR.value, 0);
        var hi = num(maxR.value, max);
        var g = gap();
        if (lo > hi - g) {
          if (e && e.target === minR) minR.value = Math.max(0, hi - g);
          else maxR.value = Math.min(max, lo + g);
        }
        repaint(range);
      }

      function commit() {
        var max = readMax(range, maxR);
        var lo = Math.min(Math.max(num(minR.value, 0), 0), max);
        var hi = Math.min(Math.max(num(maxR.value, max), 0), max);
        if (txtMin) {
          txtMin.value = lo > 0 ? String(lo) : '';
          txtMin.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (txtMax) {
          txtMax.value = hi < max ? String(hi) : '';
          txtMax.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      minR.addEventListener('input', onInput);
      maxR.addEventListener('input', onInput);
      minR.addEventListener('change', commit);
      maxR.addEventListener('change', commit);
    }

    function refresh() {
      document.querySelectorAll('[data-gcol-range]').forEach(function (range) {
        attach(range);
        repaint(range);
      });
    }

    function schedule() {
      refresh();
      requestAnimationFrame(refresh);
      [80, 250, 600, 1200].forEach(function (t) { setTimeout(refresh, t); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', schedule, { once: true });
    } else {
      schedule();
    }

    // Eventos que Horizon emite al re-renderizar la colección tras filtrar
    document.addEventListener('collection:update', schedule);
    document.addEventListener('search:update', schedule);
    document.addEventListener('shopify:section:load', schedule);

    // Red de seguridad: observar cambios (incluye atributos y texto por si
    // Horizon hace morphing en lugar de reemplazar el nodo)
    var scope = document.querySelector('results-list') || document.body;
    if (scope && window.MutationObserver) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; refresh(); });
      }).observe(scope, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['value', 'max', 'data-max', 'data-results-count'],
        characterData: true,
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
